export default function (_this) {
  return {
    create (data, callback) {
      let widgetKey
      // let dataKey

      function createWidget (resolve) {
        let newWidget = {
          template: '',
          gsOptions: data.gsOptions,
          tab: data.tab,
          subtab: data.subtab
        }

        widgetKey = _this.getRef('widgets')
          .push(newWidget, (snapshot) => {
            resolve()
          }).key
      }

      function insertDeps () {
        return new Promise((resolve) => {
          _this.getRef('widgets/' + widgetKey + '/dependencies/posts')
            .set(widgetKey, () => {
              resolve()
            })
        })
      }

      function createWidgetData () {
        return new Promise((resolve) => {
          let tableData = {
            name: data.name
          }
          _this.getRef('widgetsData/posts/' + widgetKey)
            .set(tableData, () => (resolve()))
        })
      }

      function fillTemplate () {
        _this.getRef('widgets/' + widgetKey + '/template')
          .set(`<PostsWidget widget-key="${widgetKey}" />`, () => {
            callback(widgetKey)
          })
      }

      let promise = new Promise((resolve) => {
        createWidget(resolve)
      })

      promise
        .then(() => {
          return insertDeps()
        })
        .then(() => {
          return createWidgetData()
        })
        .then(() => {
          fillTemplate()
        })
    },
    update (data, callback) {
      let promise = new Promise((resolve) => {
        _this.getRef('widgetsData/posts/' + data.table + '/name')
          .set(data.name, () => (resolve()))
      })

      return promise;
    },
    updateOptions (options, table) {
      _this.getRef('widgetsData/posts/' + table + '/options').set(JSON.stringify(options))
    }
  }
}
